export default __webpack_public_path__ + "media/titles/title_3_locale_sv-75c79380.png";